import { render } from "./FileViewDialog.vue?vue&type=template&id=1ac0dc38&scoped=true"
import script from "./FileViewDialog.vue?vue&type=script&lang=js"
export * from "./FileViewDialog.vue?vue&type=script&lang=js"

import "./FileViewDialog.vue?vue&type=style&index=0&id=1ac0dc38&scoped=true&lang=scss"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac0dc38"]])

export default __exports__